import mongoose from "mongoose";

export interface User {
  _id: mongoose.Schema.Types.ObjectId;
  id: string; // primary sub
  firstName: string;
  lastName: string;
  name: string;
  _text: string;
  email: string;
  customerIds: string[];
  emailRegions: string[] | null;
  personaId: string;
  registrationState: string;
  /** @deprecated */
  registrationDescription?: string;
  userLoginMethod: string;
  /**
   * IDP name, like "hpid", 'onehp", or "azure"
   */
  identityProvider: string;
  /**
   * User ID from "real" IDP
   */
  externalId?: string;
  /**
   * Azure/etc tenant ID
   */
  externalTenantId?: string;
  preferences?: string;
  /**
   * All SUBs
   */
  sub?: string[];
  /** @deprecated */
  category?: {
    categoryId: string;
    categoryName: string;
  }
  categoryId?: string;
  site?: {
    name1?: string;
    name2?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    stateOrProvince?: string;
    postalCode?: string;
    country?: string;
    siteName?: string;
  }
  createType?: string;
  createdBy?: string;
  createdAt?: Date;
  changedAt?: Date;
  /** @deprecated */
  consentCollected?: Date;
  preferencesSet?: boolean;
  lastLogin?: Date;
  lastAudit?: Date;
  coolDown?: Date;
}

export const UserSchema = new mongoose.Schema<User>({
  id: { type: String, unique: true, index: true, required: true },
  firstName: { type: String, index: true },
  lastName: { type: String, index: true },
  name: { type: String, index: true },
  _text: { type: String, index: true },
  email: { type: String, required: true, index: true },
  customerIds: { type: [String], index: true },
  emailRegions: { type: [String], index: true, default: () => null },
  personaId: { type: String, index: true },
  registrationState: {
    type: String,
    required: true,
    default: "REGISTERED",
  },
  registrationDescription: String,
  userLoginMethod: String,
  identityProvider: String, // IDP name - "hpid", "onehp", or "azure"
  externalId: String, // User ID from the actual IDP
  externalTenantId: String, // Azure or similar tenant
  preferences: String,
  sub: { type: [String], index: true },
  /**
   * @optional
   * @deprecated
   */
  category: {
    categoryId: String,
    categoryName: String,
  },
  categoryId: String,
  /**
   * @optional
   */
  site: {
    name1: String,
    name2: String,
    addressLine1: String,
    addressLine2: String,
    city: String,
    stateOrProvince: String,
    postalCode: String,
    country: String,
    siteName: String,
  },
  createType: String,
  createdBy: String,
  createdAt: Date,
  changedAt: Date,
  consentCollected: Date,
  preferencesSet: Boolean,
  lastLogin: Date,
  lastAudit: Date,
  coolDown: Date,
});

export const searchProps: (keyof User)[] = [
  "_text",
  "firstName",
  "lastName",
  "name",
  "email",
];

export const filterProps: (keyof User)[] = [
  "customerIds",
  "personaId",
  "registrationState",
  "categoryId",
];

export const userUtils = {
  searchProps,
  filterProps,
};
